import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'rebass'
import { rem } from 'polished'
import { media } from '../../../utils/style'
import IconArrowRight from '../../../vectors/IconArrowRight'

export const FlexWrapper = styled(({ theme, joined, ...rest }) => (
  <Flex {...rest} />
))`
  width: 100%;
  ul li {
    display: inline;
  }
`

export const ArrowRight = styled(IconArrowRight)`
  width: 10px;
  margin-right: 5px;
  path {
    fill: ${(props) => props.theme.colors.blue};
  }
`

export const BasicLink = styled.span`
  position: relative;
  width: 100%;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: ${(props) => props.theme.weights[1]};
  font-size: ${(props) => rem(props.theme.fontSizes[2])};
  color: ${(props) => props.theme.colors.white};
  transition: background-color 0.8s ${(props) => props.theme.ease.ease_out_expo};

  &:hover {
    color: ${(props) => props.theme.colors.white};
  }

  ${media.LargeScreenUp`
  margin-bottom: 1px;
  `};
`

export const TabWrapper = styled(Box)`
  position: relative;
  z-index: 1;
  text-align: center;
  width: 100%;

  label {
    text-transform: none;
    font-weight: ${(props) => props.theme.weights[0]};
    font-size: medium;
    color: ${(props) => props.theme.colors.grey_op80};
    line-height: 2.45;
  }
  input[type='radio']:checked + label {
    font-weight: ${(props) => props.theme.weights[1]};
  }
  fieldset {
    text-align: left;
  }
  h2 {
    color: ${(props) => props.theme.colors.white};
  }
  .react-tabs__tab-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .react-tabs__tab {
    color: ${(props) => props.theme.colors.grey_light_op65};
    font-size: ${(props) => rem(props.theme.fontSizes[2])};
    background-color: ${(props) => props.theme.colors.grey_op10};
    line-height: 1.6;
    cursor: pointer;
    display: inline-block;
    margin: 1px;
    padding: ${rem(13)} 1% ${rem(17)};
    width: 49%;
    ${media.LargeScreenUp`
    float: left;
    max-width: 24.7%;
    `};

    &:hover {
      transition: background-color 0.8s
          ${(props) => props.theme.ease.ease_out_circ},
        color 0.8s ${(props) => props.theme.ease.ease_out_expo};
      a {
        display: block;
        text-transform: none;
        color: ${(props) => props.theme.colors.grey_light_op65};
        ${media.LargeScreenUp`
        display: static;
        `};
      }
      &:hover {
        background-color: ${(props) => props.theme.colors.grey};
      }
      &:hover,
      &:hover a {
        color: ${(props) => props.theme.colors.grey_light};
        background-color: ${(props) => props.theme.colors.grey};
      }
    }

    &:hover {
      transition: background-color 0.8s
          ${(props) => props.theme.ease.ease_out_circ},
        color 0.8s ${(props) => props.theme.ease.ease_out_expo};
      a {
        display: block;
        text-transform: none;
        color: ${(props) => props.theme.colors.grey_light_op65};
        ${media.LargeScreenUp`
        display: static;
        `};
      }
      &:hover {
        background-color: ${(props) => props.theme.colors.grey};
      }
      &:hover,
      &:hover a {
        color: ${(props) => props.theme.colors.grey_light};
        background-color: ${(props) => props.theme.colors.grey};
      }
    }
  }

  .react-tabs__tab--selected {
    color: ${(props) => props.theme.colors.grey_light};
    background-color: ${(props) => props.theme.colors.grey};
    a,
    &:hover a {
      color: ${(props) => props.theme.colors.blue};
    }
  }
`

export const SpecDetail = styled(Box)`
  text-align: left;
  color: white;
`

export const CenterCta = styled(Box)`
  text-align: center;
  a {
    margin-bottom: ${rem(15)};
    width: 100%;
  }

  ${media.GiantScreenUp`
  text-align: left;
  a {
    width: auto;
  }
  `};
`

export const CtaLink = styled.a`
  color: ${(props) => props.theme.colors.white};
  display: block;
  width: 100%;
  text-decoration: none;
  font-weight: ${(props) => props.theme.weights[1]};
  font-size: ${(props) => rem(props.theme.fontSizes[2])};

  &:hover {
    color: ${(props) => props.theme.colors.white};
  }

  &[disabled] {
    color: rgba(255, 255, 255, 0.5);
    pointer-events: none;
  }

  svg {
    vertical-align: -5px;
  }

  path {
    fill: ${(props) => props.theme.colors.white};
  }

  ${media.LargeScreenUp`
    font-size: ${(props) => rem(props.theme.fontSizes[3])};
    padding: 0 2px;

    svg {
      vertical-align: -4px;
    }
  `};
`

export const SpecBreakout = styled(Box)`
  text-align: center;
  color: white;
  p {
    text-transform: uppercase;
  }
`
